import * as React from 'react';
import { SurfaceContextWithProperties } from '../../../types/contexts';
import { createSurfaceContextWithPropertiesProvider } from '../../common/surface-context-provider';
import { TakeSnapshotDialogProps } from './take-snapshot-dialog';

export type TakeSnapshotDialogProperties = Omit<TakeSnapshotDialogProps, 'isOpen' | 'onDismiss'>;

export const TakeSnapshotDialogContext = React.createContext<
    SurfaceContextWithProperties<TakeSnapshotDialogProperties>
>({
    isOpen: false,
});

export const TakeSnapshotDialogContextProvider =
    createSurfaceContextWithPropertiesProvider<TakeSnapshotDialogProperties>(TakeSnapshotDialogContext);